// { lat, lng } 객체로 변환
export function toPath(boundary) {
  const verts = boundary?.vertices ?? [];
  return verts
    .map((v) => ({
      lat: typeof v.latitude === "string" ? parseFloat(v.latitude) : v.latitude,
      lng:
        typeof v.longitude === "string" ? parseFloat(v.longitude) : v.longitude,
    }))
    .filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lng));
}

// 경로의 모든 점을 LatLngBounds에 extend해서 경계 박스의 중심점을 구함
export function getBoundsCenter(path) {
  const b = new window.google.maps.LatLngBounds();
  path.forEach((p) => b.extend(p));
  return b.getCenter(); // returns LatLng
}
